import ConditionalLoader from '@Guidelines/Component/Loader/ConditionalLoader';
import { PermissionEnum } from '@Application/Security/Roles';
import { openBeneficiaryToArchive } from '@UI/Pages/Beneficiaries/BeneficiaryDetails/Signals/beneficiaryToArchiveSignal';
import { openBeneficiaryToDelete } from '@UI/Pages/Beneficiaries/BeneficiaryDetails/Signals/beneficiaryToDeleteSignal';
import WithPermission from '@UI/Providers/PermissionProvider/WithPermission';
import { css } from '@emotion/react';
import * as React from 'react';
import { Button } from '@verclam/ui-kit';

const dangerZoneStyle = css`
	display: flex;
	flex-direction: column;
	align-items: flex-start;
	gap: 0.625rem;
`;

const dangerZoneActionsStyle = css`
	display: flex;
	flex-direction: column;
	align-items: flex-start;
	gap: 0.5rem;
`;

type Props = {
	readonly beneficiaryId: number;
	readonly isArchived: boolean;
};

/** Closing link of the dossier: reveals the archive/unarchive and delete actions. A leaf action component. */
const BeneficiaryDangerZone: React.FC<Props> = ({ beneficiaryId, isArchived }) => {
	const [isOpen, setIsOpen] = React.useState(false);

	const handleToggle = React.useCallback(() => {
		setIsOpen((current) => !current);
	}, []);

	const handleArchiveClick = React.useCallback(() => {
		openBeneficiaryToArchive(beneficiaryId);
	}, [beneficiaryId]);

	const handleDeleteClick = React.useCallback(() => {
		openBeneficiaryToDelete(beneficiaryId);
	}, [beneficiaryId]);

	return (
		<WithPermission permission={PermissionEnum.SUBJECT_REMOVE}>
			<div css={dangerZoneStyle}>
				<Button type="button" text label="Archiver ou supprimer ce dossier" onClick={handleToggle} />
				<ConditionalLoader data={isOpen}>
					<div css={dangerZoneActionsStyle}>
						<Button
							type="button"
							text
							label={isArchived ? 'Désarchiver le dossier' : 'Archiver le dossier'}
							onClick={handleArchiveClick}
						/>
						<Button
							type="button"
							text
							severity="danger"
							label="Supprimer définitivement"
							onClick={handleDeleteClick}
						/>
					</div>
				</ConditionalLoader>
			</div>
		</WithPermission>
	);
};

export default BeneficiaryDangerZone;
